module.exports = __webpack_public_path__ + "static/media/20.fa4cc8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/20.png
// module id = 1061
// module chunks = 0